import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import MultinationalTabs from '../../../../components/MultinationalTabs';
import TextEditor from '../../../../components/TextEditor/TextEditor';
import { clientTermsAndPrivacy } from '../../../../redux/slices/clientsSlice';

export default function SpecificPrivacy({
    data,
    onChangeMultinational,
    excludedCodes,
    onSave,
}) {
    const termsAndPrivacy = useSelector(clientTermsAndPrivacy);
    const countriesLocalizationsData = useMemo(
        () =>
            termsAndPrivacy?.policy?.reduce((acc, el) => {
                acc[el.country_code] = {
                    privacy_policy: el.privacy_policy,
                };
                return acc;
            }, {}),
        [termsAndPrivacy],
    );

    return (
        <MultinationalTabs excludedCodes={excludedCodes}>
            <TextEditor
                onChange={onChangeMultinational}
                data={data}
                onSave={onSave}
                currentPage="privacy_policy"
                title="Privacy policy"
                initialData={countriesLocalizationsData}
            />
        </MultinationalTabs>
    );
}
